import React, { useState } from 'react';
import { User2Icon, CreditCardIcon, BellIcon, ShieldIcon, KeyIcon, UserIcon, SmileIcon, CatIcon, DogIcon, BirdIcon, ChevronRightIcon, BarChart3Icon, ClockIcon, StarIcon, BoxIcon, AwardIcon, ZapIcon, BrainIcon } from 'lucide-react';
import { mockApps } from '../utils/mockData';
import { useNavigate } from 'react-router-dom';
const avatarOptions = [{
  icon: <UserIcon className="h-6 w-6" data-id="element-2088" />,
  name: 'Default'
}, {
  icon: <SmileIcon className="h-6 w-6" data-id="element-2089" />,
  name: 'Smile'
}, {
  icon: <CatIcon className="h-6 w-6" data-id="element-2090" />,
  name: 'Cat'
}, {
  icon: <DogIcon className="h-6 w-6" data-id="element-2091" />,
  name: 'Dog'
}, {
  icon: <BirdIcon className="h-6 w-6" data-id="element-2092" />,
  name: 'Bird'
}];
const subscriptionTiers = [{
  name: 'Free',
  price: '$0',
  current: true,
  features: ['10 Created AI Apps', '2,000 Monthly Credits', 'Basic Support', 'Community Access']
}, {
  name: 'Pro',
  price: '$9.99/mo',
  current: false,
  features: ['Unlimited Created Apps', '50,000 Monthly Credits', 'Priority Support', 'API Access', 'No Ads']
}, {
  name: 'Enterprise',
  price: 'Custom',
  current: false,
  features: ['Custom AI Models', 'Unlimited Credits', 'Dedicated Support', 'Team Management', 'Custom Integration']
}];
export const MyAccount = () => {
  const navigate = useNavigate();
  const [selectedAvatar, setSelectedAvatar] = useState(0);
  // Calculate mock statistics
  const totalApps = mockApps.length;
  const totalUsage = '234'; // This would come from real usage data
  const avgRating = 4.8;
  const StatCard = ({
    icon: Icon,
    label,
    value
  }: any) => <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-2093">
      <div className="flex items-center justify-between mb-4" data-id="element-2094">
        <div className="text-gray-500" data-id="element-2095">{label}</div>
        <Icon className="h-5 w-5 text-gray-400" data-id="element-2096" />
      </div>
      <div className="text-2xl font-semibold" data-id="element-2097">{value}</div>
    </div>;
  return <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8" data-id="element-2098">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-2099">
        {/* Badges Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2100">
          <div className="px-6 py-8" data-id="element-2101">
            <h2 className="text-2xl font-bold mb-6" data-id="element-2102">My Badges</h2>
            <div className="flex flex-wrap gap-4" data-id="element-2103">
              <div className="flex items-center space-x-3 bg-indigo-50 border border-indigo-200 rounded-full px-4 py-2" data-id="element-2104">
                <AwardIcon className="h-5 w-5 text-indigo-600" data-id="element-2105" />
                <span className="text-indigo-700 font-medium" data-id="element-2106">Developer</span>
              </div>
              <div className="flex items-center space-x-3 bg-purple-50 border border-purple-200 rounded-full px-4 py-2" data-id="element-2107">
                <ZapIcon className="h-5 w-5 text-purple-600" data-id="element-2108" />
                <span className="text-purple-700 font-medium" data-id="element-2109">
                  Early Adopter
                </span>
              </div>
              <div className="flex items-center space-x-3 bg-green-50 border border-green-200 rounded-full px-4 py-2" data-id="element-2110">
                <BrainIcon className="h-5 w-5 text-green-600" data-id="element-2111" />
                <span className="text-green-700 font-medium" data-id="element-2112">Super Nerd</span>
              </div>
            </div>
          </div>
        </div>
        {/* Credits Usage Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2113">
          <div className="px-6 py-8" data-id="element-2114">
            <h2 className="text-2xl font-bold mb-6" data-id="element-2115">Credits</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2116">
              <div className="p-6 border border-gray-200 rounded-lg" data-id="element-2117">
                <div className="flex justify-between items-center mb-4" data-id="element-2118">
                  <span className="text-gray-600" data-id="element-2119">Available Credits</span>
                  <ZapIcon className="h-5 w-5 text-amber-500" data-id="element-2120" />
                </div>
                <div className="text-3xl font-bold" data-id="element-2121">1,459</div>
                <div className="text-sm text-gray-500 mt-2" data-id="element-2122">
                  Resets in 12 days
                </div>
              </div>
              <div className="p-6 border border-gray-200 rounded-lg" data-id="element-2123">
                <div className="flex justify-between items-center mb-4" data-id="element-2124">
                  <span className="text-gray-600" data-id="element-2125">Used This Month</span>
                  <BarChart3Icon className="h-5 w-5 text-indigo-500" data-id="element-2126" />
                </div>
                <div className="text-3xl font-bold" data-id="element-2127">541</div>
                <div className="text-sm text-gray-500 mt-2" data-id="element-2128">
                  of 2,000 monthly credits
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Profile Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2129">
          <div className="px-6 py-8" data-id="element-2130">
            <h2 className="text-2xl font-bold mb-6" data-id="element-2131">My Profile</h2>
            <div className="flex flex-col sm:flex-row items-start gap-8" data-id="element-2132">
              <div className="w-full sm:w-64" data-id="element-2133">
                <div className="mb-4" data-id="element-2134">
                  <div className={`w-32 h-32 rounded-full bg-indigo-100 flex items-center justify-center mb-4`} data-id="element-2135">
                    {avatarOptions[selectedAvatar].icon}
                  </div>
                  <button className="text-sm text-indigo-600 hover:text-indigo-700" data-id="element-2136">
                    Change Avatar
                  </button>
                </div>
                <div className="grid grid-cols-5 gap-2" data-id="element-2137">
                  {avatarOptions.map((option, index) => <button key={index} className={`p-2 rounded-lg border ${selectedAvatar === index ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200 hover:border-indigo-600'}`} onClick={() => setSelectedAvatar(index)} data-id="element-2138">
                      {option.icon}
                    </button>)}
                </div>
              </div>
              <div className="flex-1 w-full" data-id="element-2139">
                <div className="space-y-4" data-id="element-2140">
                  <div data-id="element-2141">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2142">
                      Display Name
                    </label>
                    <input type="text" defaultValue="John Doe" className="w-full border-gray-200 rounded-md px-4 py-2" data-id="element-2143" />
                  </div>
                  <div data-id="element-2144">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2145">
                      Email
                    </label>
                    <input type="email" defaultValue="john@example.com" className="w-full border-gray-200 rounded-md px-4 py-2" data-id="element-2146" />
                  </div>
                  <div data-id="element-2147">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2148">
                      Bio
                    </label>
                    <textarea className="w-full border-gray-200 rounded-md px-4 py-2" rows={3} defaultValue="AI enthusiast and developer" data-id="element-2149" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Dashboard Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2150">
          <StatCard icon={BoxIcon} label="Total Apps" value={totalApps} data-id="element-2151" />
          <StatCard icon={ClockIcon} label="Total Usage" value={`${totalUsage}h`} data-id="element-2152" />
          <StatCard icon={StarIcon} label="Avg. Rating" value={avgRating} data-id="element-2153" />
        </div>
        {/* Subscription Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2154">
          <div className="px-6 py-8" data-id="element-2155">
            <h2 className="text-2xl font-bold mb-6" data-id="element-2156">Subscription</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2157">
              {subscriptionTiers.map(tier => <div key={tier.name} className={`rounded-lg border ${tier.current ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200'} p-6`} data-id="element-2158">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-2159">{tier.name}</h3>
                  <p className="text-2xl font-bold mb-4" data-id="element-2160">{tier.price}</p>
                  <ul className="space-y-2 mb-6" data-id="element-2161">
                    {tier.features.map(feature => <li key={feature} className="flex items-center text-sm" data-id="element-2162">
                        <ChevronRightIcon className="h-4 w-4 text-indigo-600 mr-2" data-id="element-2163" />
                        {feature}
                      </li>)}
                  </ul>
                  <button className={`w-full py-2 rounded-md ${tier.current ? 'bg-indigo-600 text-white' : 'border border-indigo-600 text-indigo-600'}`} data-id="element-2164">
                    {tier.current ? 'Current Plan' : 'Upgrade'}
                  </button>
                </div>)}
            </div>
          </div>
        </div>
        {/* Settings Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2165">
          <div className="px-6 py-8" data-id="element-2166">
            <h2 className="text-2xl font-bold mb-6" data-id="element-2167">Settings</h2>
            <div className="space-y-4" data-id="element-2168">
              <button onClick={() => navigate('/settings')} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-indigo-600 group" data-id="element-2169">
                <div className="flex items-center" data-id="element-2170">
                  <BellIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 mr-3" data-id="element-2171" />
                  <span data-id="element-2172">Notifications</span>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-2173" />
              </button>
              <button onClick={() => navigate('/settings')} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-indigo-600 group" data-id="element-2174">
                <div className="flex items-center" data-id="element-2175">
                  <ShieldIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 mr-3" data-id="element-2176" />
                  <span data-id="element-2177">Privacy</span>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-2178" />
              </button>
              <button onClick={() => navigate('/settings')} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-indigo-600 group" data-id="element-2179">
                <div className="flex items-center" data-id="element-2180">
                  <KeyIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 mr-3" data-id="element-2181" />
                  <span data-id="element-2182">Security</span>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-2183" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};